import React from "react";

import { t } from "@auto/services";
import EChart from "@src/reporting/components/EChart";
import ReportingWidget from "@src/reporting/components/ReportingWidget";
import useReportingResource from "@src/reporting/hooks/useReportingResource.mjs";
import { count, dateBucket } from "@src/reporting/model/reportingFormatters.mjs";
import { loadStatsTimeline } from "@src/reporting/services/reportingApi.mjs";
import styles from "@src/reporting/Reporting.module.styl";

const RegistrationTimelineWidget = () => {
  const resource = useReportingResource(
    loadStatsTimeline,
    {
      key: "timeline",
      initialData: [],
    },
  );

  const rows = resource.data || [];
  const option = React.useMemo(() => ({
    tooltip: { trigger: "axis" },
    grid: { left: 52, right: 20, top: 34, bottom: 42, containLabel: true },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: rows.map((row) => dateBucket(row.date)),
    },
    yAxis: { type: "value", minInterval: 1 },
    series: [{
      name: t("stats.applicants"),
      type: "line",
      smooth: true,
      showSymbol: true,
      symbolSize: 6,
      areaStyle: {},
      label: {
        show: true,
        position: "top",
        formatter: ({ value }) => count(value),
      },
      data: rows.map((row) => Number(row.applicationCount  || 0)),
    }],
  }), [rows]);

  return (
    <ReportingWidget
      title={t("stats.applicantActivity")}
      subtitle={t("stats.applicantActivitySubtitle")}
      loading={resource.loading}
      error={resource.error}
      empty={resource.hasLoaded && rows.length === 0}
      emptyMessage={t("stats.noData")}
    >
      <EChart option={option} loading={resource.loading} className={styles.timelineChartPublic} />
    </ReportingWidget>
  );
};

export default RegistrationTimelineWidget;
